<div class="modal {active ? 'is-active': ''}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Lineup Inning {inningNum + 1}</p>
            <button class="delete" aria-label="close" on:click='set({active: false})'></button>
        </header>
        <section class="modal-card-body">
            <div class='columns'>
                <div class='column is-half'>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Fielding
                        </div>
                        <p class='panel-block roster-player {droptarget == 1 ? "has-background-grey-light":""}' on:dragover="dragover(event,1)" on:dragleave="dragleave(event,1)" on:drop="drop(event, 1)">
                            <span class='panel-icon lineup-id'>P</span>
                            {#if inning[1].last}
                                {inning[1].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(1)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 2 ? "has-background-grey-light":""}' on:dragover="dragover(event,2)" on:dragleave="dragleave(event,2)" on:drop="drop(event, 2)">
                            <span class='panel-icon lineup-id'>C</span>
                            {#if inning[2].last}
                                {inning[2].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(2)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 3 ? "has-background-grey-light":""}' on:dragover="dragover(event,3)" on:dragleave="dragleave(event,3)" on:drop="drop(event, 3)">
                            <span class='panel-icon lineup-id'>1st</span>
                            {#if inning[3].last}
                                {inning[3].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(3)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 4 ? "has-background-grey-light":""}' on:dragover="dragover(event,4)" on:dragleave="dragleave(event,4)" on:drop="drop(event, 4)">
                            <span class='panel-icon lineup-id'>2nd</span>
                            {#if inning[4].last}
                                {inning[4].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(4)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 5 ? "has-background-grey-light":""}' on:dragover="dragover(event,5)" on:dragleave="dragleave(event,5)" on:drop="drop(event, 5)">
                            <span class='panel-icon lineup-id'>3rd</span>
                            {#if inning[5].last}
                                {inning[5].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(5)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 6 ? "has-background-grey-light":""}' on:dragover="dragover(event,6)" on:dragleave="dragleave(event,6)" on:drop="drop(event, 6)">
                            <span class='panel-icon lineup-id'>SS</span>
                            {#if inning[6].last}
                                {inning[6].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(6)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 7 ? "has-background-grey-light":""}' on:dragover="dragover(event,7)" on:dragleave="dragleave(event,7)" on:drop="drop(event, 7)">
                            <span class='panel-icon lineup-id'>LF</span>
                            {#if inning[7].last}
                                {inning[7].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(7)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 8 ? "has-background-grey-light":""}' on:dragover="dragover(event,8)" on:dragleave="dragleave(event,8)" on:drop="drop(event, 8)">
                            <span class='panel-icon lineup-id'>CF</span>
                            {#if inning[8].last}
                                {inning[8].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(8)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player {droptarget == 9 ? "has-background-grey-light":""}' on:dragover="dragover(event,9)" on:dragleave="dragleave(event,9)" on:drop="drop(event, 9)">
                            <span class='panel-icon lineup-id'>RF</span>
                            {#if inning[9].last}
                                {inning[9].last}
                                <span class='panel-icon is-pulled-right has-text-danger' on:click="clearPlayer(9)">
                                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                                </span>
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                    </nav>
                </div>
                <div class='column is-half'>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Available Players
                        </div>
                        {#each availablePlayers as player}
                        <p class='panel-block has-background-white' draggable="true" on:dragstart="dragstart(event, player.number)" on:dragend="dragend(event)">
                            <span class='panel-icon lineup-id'>{player.number}</span>
                            {#if player.last}{player.last}, {player.first}{:else}&nbsp;{/if}
                        </p>
                        {/each}
                    </nav>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Bookmarked Lineups
                        </div>
                        <div class='panel-block has-background-white'>
                            <div class="control">
                                <div class="select">
                                    <select bind:value=bookmarkName>
                                        <option></option>
                                        {#each Object.keys($bookmarkedLineups) as bookmark}
                                        <option>{bookmark}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                            <button class='button is-primary' on:click='applyBookmark()'>Apply</button>
                        </div>
                    </nav>
                </div>
            </div>
        </section>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                active: false,
                inningNum: 0,
                inning: [],
                droptarget: 0,
                bookmarkName: ''
            };
        },
        computed: {
            availablePlayers: function ({ inning, $activeRoster }) {
                let available = [];
                for (var playerIdx in $activeRoster) {
                    let player = $activeRoster[playerIdx];
                    let found = false;
                    let positions = [1, 2, 3, 4, 5, 6, 7, 8, 9];
                    for (var position of positions) {
                        let positionPlayer = inning[position];
                        if (positionPlayer.first == player.first && positionPlayer.last == player.last) {
                            found = true;
                        }
                    }
                    if (!found) {
                        available.push(player);
                    }
                }
                return available;
            }
        },
        methods: {
            dragstart(ev, playerNum) {
                ev.dataTransfer.setData("playerNum", playerNum);
            },
            dragend(ev) {

            },
            dragover(ev, position) {
                ev.preventDefault();
                this.set({droptarget: position})
                ev.dataTransfer.dropEffect = 'move';
            },
            dragleave(ev, position) {
                ev.preventDefault();
                const {droptarget} = this.get();
                if(droptarget == position) {
                    this.set({droptarget: 0});
                }
            },
            drop(ev, position) {
                ev.preventDefault();
                var playerNum = ev.dataTransfer.getData("playerNum");
                const {activeRoster} = this.store.get();
                let movedPlayer = activeRoster.find(function(player) {
                    return player.number == playerNum;
                });
                if(movedPlayer) {
                    const { inning, inningNum } = this.get();
                    inning[position] = movedPlayer;
                    this.set({ inning });
                    const {lineups} = this.store.get();
                    lineups[inningNum] = inning;
                    this.store.set({lineups});
                }
                this.set({droptarget: 0});
            },
            clearPlayer(position) {
                const { inning, inningNum } = this.get();
                inning[position] = {};
                this.set({ inning });
                const {lineups} = this.store.get();
                lineups[inningNum] = inning;
                this.store.set({lineups});
            },
            applyBookmark() {
                const {bookmarkName, inningNum} = this.get();
                const {bookmarkedLineups, lineups} = this.store.get();
                lineups[inningNum] = bookmarkedLineups[bookmarkName];
                this.set({bookmarkName: ''});
                this.store.set({lineups});
            }
        }
    }
</script>

<style>
    [draggable] {
        user-select: none;
        -webkit-user-drag: element;
    }
    .fa-lg {
        line-height: 1em;
    }
    .panel-icon {
        vertical-align: inherit;
    }
    .roster-player {
        display: block;
        padding: 0.4em 0.75em;
    }
</style>
